/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa Redirect To The Right Store
 *
 */
Intesa.RedirectToRightStore = function () {

	/**
	 *  Variables
	 *
	 */

	var redirectToRightStore = this;
	var userAgent = navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase() || window.opera.toLowerCase();
	const huaweiStore = "HUAWEI_STORE";
	const googleStore = "GOOGLE_STORE";
	const appleStore = "APPLE_STORE";
	const defaultLabel = "default";


	/**
	 * Init component
	 *
	 */

	this.init = function () {

		console.log("Intesa.RedirectToRightStore - START ")

		var mobileStore = redirectToRightStore.getMobileStore();

		console.log("returned store -> ", mobileStore);

		redirectToRightStore.fillComponents(mobileStore);

		console.log("Intesa.RedirectToRightStore - END ")


	}

	this.fillComponents = function (type) {

		var link = null;

		var isQr = null;

		$(".hom5__panel__dynamic").each(function () {
			var dataElement = $(this).find(".hom5__linkContainer__dynamic");
			var id = dataElement.attr("data-id");
			var qrElementId = "qr-" + id;
			switch (type) {
				case appleStore:
					dataElement.find(".iosLink").removeClass("hide");
					isQr = dataElement.attr("data-qr-ios") == "true";
					if (isQr) {
						link = dataElement.attr("data-ios");
						var qrIos = new QRious({
							element: document.getElementById(qrElementId),
							value: link
						});
						//Customize qr here
						qrIos.set({
							background: 'white',
							backgroundAlpha: 1,
							foreground: 'black',
							foregroundAlpha: 1,
							level: 'H',
							padding: null,
							size: 125
						});
					}
					break;
				case googleStore:
					dataElement.find(".googleLink").removeClass("hide");
					isQr = dataElement.attr("data-qr-android") == "true";
					if (isQr) {
						link = dataElement.attr("data-android");
						var qrAndroid = new QRious({
							element: document.getElementById(qrElementId),
							value: link
						});
						//Customize qr here
						qrAndroid.set({
							background: 'white',
							backgroundAlpha: 1,
							foreground: 'black',
							foregroundAlpha: 1,
							level: 'H',
							padding: null,
							size: 125
						});
					}
					break;
				case huaweiStore:
					dataElement.find(".huaweiLink").removeClass("hide");
					isQr = dataElement.attr("data-qr-huawei") == "true";
					if (isQr) {
						link = dataElement.attr("data-huawei");
						var qrHuawei = new QRious({
							element: document.getElementById(qrElementId),
							value: link
						});
						//Customize qr here
						qrHuawei.set({
							background: 'white',
							backgroundAlpha: 1,
							foreground: 'black',
							foregroundAlpha: 1,
							level: 'H',
							padding: null,
							size: 125
						});
					}
					break;
				case defaultLabel:
					dataElement.parent().find(".defaultLink").removeClass("hide");
					isQr = dataElement.attr("data-qr-default") == "true";
					if (isQr) {
						link = dataElement.attr("data-default");
						var qrDefault = new QRious({
							element: document.getElementById(qrElementId),
							value: link
						});
						//Customize qr here
						qrDefault.set({
							background: 'white',
							backgroundAlpha: 1,
							foreground: 'black',
							foregroundAlpha: 1,
							level: 'H',
							padding: null,
							size: 125
						});
					}
					break;
			}
		});



	}

	this.mobileCheck = function () {
		var check = false;
		(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	};


	this.iOS = function () {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	this.isHuaweiDevice = function () {

		var check = false;
		check = navigator.usertAgentData.brands.forEach(function (element) {
			if (element.brand != undefined && element.brand.toLowerCase().includes("huawei")) {
				return true
			}
		});

		return check;

	}

	this.getMobileStore = function () {

		//Huawei models serial codes with GMS --- Important | this check is relevant only if the device has been recognized as a Huawei device

		var checkHuaweiWhitelist = userAgent.match(/"ALP-"|"AMN-"|"ANE-"|"AN,G-"|"AQM-"|"ARS-"|"ART-"|"ATU-"|"BAC-"|"BLA-"|"BRQ-"|"CAG-"|"CAM-"|"CAN-"|"CAZ-"|"CDL-"|"CLT-"|"CRO-"|"CUN-"|"DIG-"|"DRA-"|"DUA-"|"DUB-"|"DVC-"|"ELE-"|"EML-"|"EVA-"|"EVR-"|"FIG-"|"FLA-"|"FRL-"|"GLK-"|"HMA-"|"HW-"|"HWI-"|"INE-"|"JAT-"|"JKM-"|"JSC-"|"LDN-"|"LON-"|"LUA-"|"LYA-"|"LYO-"|"MAR-"|"MED-"|"MHA-"|"MLA-"|"MRD-"|"MYA-"|"NCE-"|"NEO-"|"NOH-"|"NOP-"|"OCE-"|"PAR-"|"PIC-"|"POT-"|"PPA-"|"PRA-"|"RNE-"|"SEA-"|"SLA-"|"SNE-"|"SPN-"|"STK-"|"TET-"|"TRT-"|"VCE-"|"VIE-"|"VKY-"|"VNS-"|"VOG-"|"VTR-"|"WAS-"|"WKG-"|"WLZ-"|"YAL"/i)

		var isMobile = redirectToRightStore.mobileCheck();

		if (isMobile) {

			var isUserAgentData = navigator.usertAgentData != undefined ? true : false;

			var isIos = redirectToRightStore.iOS();

			if (isIos) return appleStore;

			if (isUserAgentData) {

				isHuaweiDevice = redirectToRightStore.isHuaweiDevice();

				if (isHuaweiDevice) {

					if (checkHuaweiWhitelist) {

						console.log("detected huawei with GMS")

						return googleStore;

					} else {

						console.log("detected huawei without GMS")

						return huaweiStore;

					}

				}

			} else {

				if (userAgent.includes("huawei")) {

					if (checkHuaweiWhitelist) {

						console.log("detected huawei with GMS")

						return googleStore;

					} else {

						console.log("detected huawei without GMS")

						return huaweiStore;

					}

				} else {

					return googleStore;
				}

			}

		} else {

			return defaultLabel;

		}
	}

}

/**
 * Get class instance
 *
 */
Intesa.RedirectToRightStore.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.redirectToRightStore) {

		window.intesa.redirectToRightStore = new Intesa.RedirectToRightStore();

	}

	return window.intesa.redirectToRightStore;

};